import { frontendURL } from '../../../../helper/URLHelper';
import NucleoWorkOrderDetailPage from '../pages/NucleoWorkOrderDetailPage.vue';
import NucleoWorkOrdersPage from '../pages/NucleoWorkOrdersPage.vue';
import SalesDetailPage from '../pages/SalesDetailPage.vue';
import { nucleoPermissions } from './permissions';

export const nucleoRoutes = [
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/nucleo/:salesTransactionId/detalhes-venda'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/nucleo/:salesTransactionId/detalhes-venda'
      ),
    ],
    name: 'operacao_imobiliaria_nucleo_venda_detalhes',
    component: SalesDetailPage,
    meta: { permissions: nucleoPermissions },
  },
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/nucleo/:imovelListingId/servicos/:workOrderId'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/nucleo/:imovelListingId/servicos/:workOrderId'
      ),
    ],
    name: 'operacao_imobiliaria_nucleo_detalhe',
    component: NucleoWorkOrderDetailPage,
    meta: { permissions: nucleoPermissions },
  },
  {
    path: frontendURL('accounts/:accountId/operacao-imobiliaria/nucleo'),
    alias: [frontendURL('accounts/:accountId/nucleo')],
    name: 'operacao_imobiliaria_nucleo',
    component: NucleoWorkOrdersPage,
    meta: { permissions: nucleoPermissions },
  },
];
